import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SkeletonComponent } from '@ui-lib';

@Component({
  selector: 'provider-portal-patient-quick-view-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, SkeletonComponent],
  templateUrl: './patient-quick-view-card.component.html',
})
export class PatientQuickViewCardComponent {
  readonly title = input.required<string>();
  readonly svgIcon = input.required<string>();

  readonly iconClass = input('text-gray-500!');
  readonly loading = input(false);
  readonly failed = input(false);
  readonly isEmpty = input(false);
  readonly emptyText = input('No current items');
  readonly showViewAll = input(true);

  readonly retried = output<void>();
  readonly viewAll = output<void>();

  protected readonly skeletonRows = [0, 1, 2];
}
